<template>
  <div class="container">
    <contact-bar></contact-bar>
    <navigation-bar></navigation-bar>
    <div class="block pt-6">
      <div class="columns is-centered is-mobile">
        <div class="column is-two-thirds">
          <h1
            class="has-text-centered has-text-primary"
            :class="width < 768 ? 'is-size-3' : 'is-size-1'"
            style="font-family: Calibri; font-weight: bold"
          >
            REPRESENTAMOS MARCAS SEGURAS, EFICIENTES Y DURABLES
          </h1>
        </div>
      </div>
      <div class="colums is-centered is-two-thirds">
        <div class="column is-10 is-offset-1">
          <p
            class="has-text-centered has-text-primary is-size-5 p-5"
            style="font-family: Calibri"
          >
            Nos hemos aliado estratégicamente con marcas destacadas en sus
            respectivas especialidades, con el objetivo de mejorar la eficiencia
            en la producción, reducir los costos operativos y elevar la calidad
            de los productos para beneficio de nuestros clientes.
          </p>
        </div>
      </div>
    </div>
  </div>
  <representadas-component></representadas-component>
  <section class="hero has-background-blue pt-6 pb-6">
    <div class="hero-body">
      <div class="container">
        <h1
          class="has-text-centered has-text-white"
          :class="width < 768 ? 'is-size-3' : 'is-size-1'"
          style="font-family: Calibri; font-weight: bold"
        >
          PONTE EN CONTACTO CON NOSOTROS
        </h1>
        <div class="columns is-centered is-mobile">
          <div class="column is-two-thirds">
            <p
              class="has-text-white has-text-centered is-size-6 pt-4 pb-6"
              style="font-family: Calibri; font-weight: bold"
            >
              Valoramos la durabilidad en las relaciones. Creemos en la
              confianza, la lealtad y el compromiso como pilares clave. Nuestra
              filosofía se refleja en cada proyecto, marcando la diferencia en
              el mercado y más allá.
            </p>
          </div>
        </div>
        <div class="is-mobile level">
          <div class="level-item">
            <button
              class="button is-hoverable has-background-yellow has-text-white is-normal"
              style="
                font-family: Calibri;
                font-weight: bold;
                border: none;
                width: 15rem;
                height: 3rem;
              "
            >
              CONTACTA A UN ASESOR
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <footer-component></footer-component>
</template>
<script setup lang="ts">
import ContactBar from "@/components/ContactBar.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import RepresentadasComponent from "@/components/RepresentadasComponent.vue";
import { useWindowSize } from "vue-window-size";

const { width } = useWindowSize();
</script>
